<template>

	<div class="car-manage">
		<!-- 查找参数区 -->
		<div class="filter-container">
			<el-input placeholder="请输入机器人名称" v-model="listQuery.params.device_name" style="width: 200px"
				class="filter-item" maxlength="20"
				@input="e => listQuery.params.device_name = e.replace(/[^a-zA-Z\u4e00-\u9fa5\d]+$/g,'')">
			</el-input>
			<el-input placeholder="请输入机器人Id" v-model="listQuery.params.device_id"
				style="width: 200px;padding-left: 20px;" class="filter-item" maxlength="20"
				@input="e => listQuery.params.device_id = e.replace(/[^a-zA-Z\u4e00-\u9fa5\d]+$/g,'')">
			</el-input>
			<el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
				@click="handleQuery">
				搜索
			</el-button>
		</div>

		<!-- 数据列表区 -->
		<el-table :data="listData" v-loading="listLoading" border highlight-current-row
			style="width: 100%;align: center;">
			<el-table-column prop="deviceId" label="机器人ID" width="200" align="center">
			</el-table-column>
			<el-table-column prop="deviceName" label="机器人名称" align="center">
			</el-table-column>
			<el-table-column prop="devicePic" label="机器人图片" width="300" align="center">
			</el-table-column>
			<el-table-column prop="wifiName" label="WIFI名称" align="center">
			</el-table-column>
			<el-table-column prop="wifiPassword" label="WIFI密码" align="center">
			</el-table-column>
			<el-table-column prop="userName" label="所属用户" align="center">
			</el-table-column>
			<el-table-column prop="operator" label="操作" width="150" align="center">
				<template v-slot:="{row,$index}">
					<el-select value="操作类型">
						<el-option v-for="(item, index) in tableOptions" :key="item" :value="index"
							@click.native="handleOperator(index, row)">
							{{item}}
						</el-option>
					</el-select>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页栏 -->
		<pagination :total="totalCounts" @pagination="handlePageChange">
		</pagination>

		<!-- 编辑车辆信息弹出框 -->
		<el-dialog title="编辑机器人信息" :visible.sync="formVisable">
			<el-form :model="formData" ref="formData" label-position="right" label-width="80px">
				<el-form-item style="display: none;">
					<el-input v-model="formData.id" readonly></el-input>
				</el-form-item>
				<el-form-item label="机器人图片">
					<el-input v-model="formData.devicePic" maxlength="255"></el-input>
				</el-form-item>
				<el-form-item label="WIFI名称" prop="wifiName">
					<el-input v-model="formData.wifiName" maxlength="100"
						@input="e => formData.wifiName = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
				</el-form-item>
				<el-form-item label="WIFI密码" prop="wifiPassword">
					<el-input v-model="formData.wifiPassword" maxlength="20"
						@input="e => formData.wifiPassword = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formVisable = false">取 消</el-button>
				<el-button type="primary" @click="handleEditForm()">确 定</el-button>
			</div>
		</el-dialog>

		<!--为车辆添加用户 -->
		<el-dialog title="用户机器人信息" :visible.sync="formUserVisable">
			<el-form :model="formUserData" ref="formUserData" label-position="right" label-width="80px">
				<el-form-item label="选择用户">
					<el-select v-model="formUserData.userName" style="width:100%">
						<el-option v-for="item in appUserOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formUserVisable = false">取 消</el-button>
				<el-button type="primary" @click="handleEditUserForm()">确 定</el-button>
			</div>
		</el-dialog>

	</div>

</template>

<script>
	import Pagination from '@/components/common/Pagination'
	import {
		listAppCar,
		updateAppCar,
		insertAppCarUser
	} from '@/api/car.js'
    import { listAppUserByEntity } from '@/api/user.js'
	
	export default {
		name: 'CarAppManage',
		components: {
			Pagination,
		},

		data() {
			return {
				listLoading: false,
				totalCounts: 0,
				listData: [],

				listQuery: {
					loginAdmin: this.$store.getters['user/userName'],
					pageIndex: 1,
					pageSize: 10,
					params: {
						device_id: undefined,
						device_name: undefined
					},
					fuzzySearch: true
				},
				tableOptions: [
					'编辑',
					'分配'
				],

				formVisable: false,
				formData: {
					id: '',
					devicePic: '',
					wifiName: '',
					wifiPassword: '',
				},

				formUserVisable: false,
				formUserData: {
					id: '',
					userName: ''
				},
				appUserOptions: [],
			}
		},
		mounted() {
			// this.handleQuery()
		},
		methods: {
			/**
			 * 查询列表
			 */
			handleQuery() {
				// this.listLoading = true
				// listAppCar(this.listQuery).then(res => {
				// 	let data = res.pageData
				// 	this.totalCounts = data.totalCounts
				// 	this.listData = data.datas
				// 	this.listLoading = false
				// })
			},

			/**
			 * @param {Object} data
			 * 翻页
			 */
			handlePageChange(data) {
				this.listQuery.pageIndex = data.page
				this.listQuery.pageSize = data.limit
				this.handleQuery()
			},


			/**
			 * 处理操作
			 */
			handleOperator(index, row) {
				switch (index) {
					case 0:
						// index: 0 表示编辑车辆
						this.editCarApp(row)
						break;
					case 1:
						// index: 2 表示给车辆添加用户
						this.addCarAppUser(row)
					default:
						break;
				}
			},
			/**
			 * @param {Object} row
			 * 编辑信息
			 */
			editCarApp(row) {
				this.formData.id = row.id
				this.formData.devicePic = row.devicePic
				this.formData.wifiName = row.wifiName
				this.formData.wifiPassword = row.wifiPassword
				this.formVisable = true
			},
			/**
			 * 提交编辑信息
			 */
			handleEditForm() {
				updateAppCar(this.formData).then(res => {
					if (res.result == '2') {
						this.$alert('编辑成功！');
						this.formVisable = false;
						this.handleQuery();
					} else {
						this.$alert(res.message);
					}
				})
			},
			
			/**
			 * @param {Object} row
			 * 车辆增加至用户
			 */
			addCarAppUser(row) {
				/**
				 * 查询APP用户列表
				 */
				listAppUserByEntity(this.$store.getters['user/entityId']).then(res =>{
					if (res.result == '200') {
					  this.appUserOptions = res.data.map((item,index) => {
					    return {
					      value: item.username,
					      label: item.username,
					    }
					  })              	
					} else {
					  this.$message.error(res.message)
					}
				}),
				this.formUserData.id = row.id
				this.formUserVisable = true
			},

			/**
			 * 数据库新增
			 */
			handleEditUserForm(){
				insertAppCarUser(this.formUserData).then(res => {
					if (res.result == '2') {
						this.$alert('分配成功！');
						this.formUserVisable = false;
						this.handleQuery();
					} else {
						this.$alert(res.message);
					}
				})
			}
			
		}

	}
</script>

<style>
</style>
